export default __webpack_public_path__ + "static/media/chatton9.5b9dc230.jpg";